import React, { useContext, useLayoutEffect, useRef } from 'react';
import { ClientsTableScrollContext } from './ClientsTableOverlayScroll';

const anchorIntersectsScroller = (anchorRect, scrollerRect) => (
    anchorRect.bottom > scrollerRect.top && anchorRect.top < scrollerRect.bottom
);

const OrderProductHintsLayer = ({ anchorRef, onAnchorHidden, children }) => {
    const scrollContext = useContext(ClientsTableScrollContext);
    const panelRef = useRef(null);
    const onAnchorHiddenRef = useRef(onAnchorHidden);
    onAnchorHiddenRef.current = onAnchorHidden;

    useLayoutEffect(() => {
        const host = scrollContext?.hostRef?.current;
        const scroller = scrollContext?.scrollerRef?.current;
        const anchor = anchorRef?.current;
        const panel = panelRef.current;
        if (!host || !scroller || !anchor || !panel) {
            return undefined;
        }

        let closed = false;

        const place = () => {
            if (closed) {
                return;
            }
            const anchorRect = anchor.getBoundingClientRect();
            const scrollerRect = scroller.getBoundingClientRect();
            if (!anchorIntersectsScroller(anchorRect, scrollerRect)) {
                closed = true;
                onAnchorHiddenRef.current();
                return;
            }
            const hostRect = host.getBoundingClientRect();
            panel.style.top = `${anchorRect.bottom - hostRect.top + 2}px`;
            panel.style.left = `${anchorRect.left - hostRect.left}px`;
            panel.style.width = `${anchorRect.width}px`;
        };

        place();
        scroller.addEventListener('scroll', place, { passive: true });
        window.addEventListener('resize', place);
        return () => {
            closed = true;
            scroller.removeEventListener('scroll', place);
            window.removeEventListener('resize', place);
        };
    }, [anchorRef, scrollContext]);

    return (
        <div ref={panelRef} className="order-product-hints order-product-hints--anchored">
            {children}
        </div>
    );
};

export default OrderProductHintsLayer;
